import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TagManager from "react-gtm-module";
import GTMRouteTracker from "./services/GTMRouteTracker";

import Login from "./pages/auth/Login";
import Maintenance from "./pages/system/Maintenance";
import Registration from "./pages/auth/Registration";
import Emission from "./pages/emissions/Emission";
import Questions from "./pages/survey/Questions";
import Checkin from "./pages/system/Checkin";
import Thanks from "./pages/survey/Thanks";
import ThanksMp from "./pages/survey/ThanksMp";
import Dashboard from "./pages/dashboard/Dashboard";
import PanelECJ from "./pages/dashboard/PanelECJ";
import Privacy from "./pages/legal/privacyPshEN";
import Debug from "./pages/system/Debug";
import PagoSuccess from "./pages/payments/Success";
import PagoFailure from "./pages/payments/Failure";
import PagoPending from "./pages/payments/Pending";
import Summary from "./pages/survey/Summary";
import Config from "./pages/config/Config";
import InvitationCodes from "./pages/config/InvitationCodes";

import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ThemeToggle from "./components/ThemeToggle";
import GlobalPopup from "./components/GlobalPopup";
import PublicMaintenanceGate from "./components/PublicMaintenanceGate";

TagManager.initialize({
  gtmId: "GTM-KXW36Z55",
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Router>
      <GTMRouteTracker />

      <LanguageProvider>
        <AuthProvider>
          <PublicMaintenanceGate>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Registration />} />
              <Route path="/registration" element={<Registration />} />
              <Route path="/maintenance" element={<Maintenance />} />

              <Route path="/emission" element={<Emission />} />

              <Route path="/questions" element={<Questions />} />

              <Route path="/summary" element={<Summary />} />

              <Route path="/success" element={<PagoSuccess />} />
              <Route path="/failure" element={<PagoFailure />} />
              <Route path="/pending" element={<PagoPending />} />

              <Route path="/checkin" element={<Checkin />} />
              <Route path="/thanks" element={<Thanks />} />
              <Route path="/thanks-mp" element={<ThanksMp />} />
              <Route path="/privacy" element={<Privacy />} />

            <Route
              path="/config"
              element={
                <ProtectedRoute>
                  <Config />
                </ProtectedRoute>
              }
            />

            <Route
              path="/config/invitation-codes"
              element={
                <ProtectedRoute>
                  <InvitationCodes />
                </ProtectedRoute>
              }
            />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/panelecj"
              element={
                <ProtectedRoute>
                  <PanelECJ />
                </ProtectedRoute>
              }
            />

            <Route
              path="/panel-ecj"
              element={
                <ProtectedRoute>
                  <PanelECJ />
                </ProtectedRoute>
              }
            />

            <Route
              path="/debug"
              element={
                <ProtectedRoute>
                  <Debug />
                </ProtectedRoute>
              }
            />
            </Routes>
          </PublicMaintenanceGate>

          <GlobalPopup />
          <ThemeToggle />
        </AuthProvider>
      </LanguageProvider>
    </Router>
  </React.StrictMode>
);


